(() => {
  'use strict';

  const button = document.querySelector('[data-dr-whatsapp-float]');
  if (!button) return;

  const selectors = [
    '.dr-cart-sticky-checkout',
    '[data-drp-sticky]',
    'sticky-add-cart'
  ];
  const mobile = window.matchMedia('(max-width: 767.98px)');
  let frame = 0;

  const baseBottom = () => mobile.matches ? 16 : 22;

  function isVisible(element) {
    if (!element || element.hidden) return false;
    const style = getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function sync() {
    frame = 0;
    let bottom = baseBottom();

    document.querySelectorAll(selectors.join(',')).forEach(element => {
      if (!isVisible(element)) return;
      const style = getComputedStyle(element);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;
      const rect = element.getBoundingClientRect();
      /* Only compensate bars that occupy the viewport's bottom edge. */
      if (rect.bottom < window.innerHeight - 12) return;
      bottom = Math.max(bottom, Math.ceil(window.innerHeight - rect.top + 14));
    });

    button.style.setProperty('--dr-wa-bottom', `${bottom}px`);
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(sync);
  }

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden']
  });

  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  document.querySelectorAll(selectors.join(',')).forEach(element => resize?.observe(element));

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  if (mobile.addEventListener) mobile.addEventListener('change', schedule);
  else mobile.addListener?.(schedule);

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('dr:cart:updated', schedule);
  document.addEventListener('dr:cart-updated', schedule);

  sync();
})();
